// @ts-ignore
'use client';
import '@mux/mux-player/themes/classic';
export default 'classic';
